import { type QueryObserverResult, useQuery } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'

import type { FeatureFlagsResponse } from '@front/type/feature-flags'

import {
  axiosPost,
  axiosPostWithoutInterceptor,
} from '../logic/axios/wrappers/axios.post.wrapper'

import { getFlagsUrl } from './config'

export const useGetFeatureTogglesQueryKey = 'get-feature-toggles'

const getFeatureTogglesQuery = () =>
  axiosPost<FeatureFlagsResponse>(getFlagsUrl, {})

export const noInterceptorGetFeatureTogglesQuery = (
  config?: AxiosRequestConfig<unknown>,
) => axiosPostWithoutInterceptor<FeatureFlagsResponse>(getFlagsUrl, {}, config)

export const useGetFeatureTogglesQuery = (
  enabled: boolean,
): QueryObserverResult<FeatureFlagsResponse> => {
  return useQuery({
    queryKey: [useGetFeatureTogglesQueryKey],
    queryFn: getFeatureTogglesQuery,
    enabled,
    gcTime: 60000,
  })
}
